<template>
  <div class="tab-cond-pagamento">
    <div class="tab-section">
      <h6 class="section-title">Condições de Pagamento Vinculadas</h6>

      <div v-if="carregando" class="text-center py-3">
        <b-spinner small /> Carregando...
      </div>

      <div v-else-if="associadas.length === 0" class="empty-state">
        <feather-icon icon="AlertCircleIcon" size="18" class="mr-1 text-muted" />
        Nenhuma condição de pagamento associada ainda.
      </div>

      <b-table
        v-else
        :items="associadas"
        :fields="campos"
        small
        striped
        responsive
        class="mb-0"
      >
        <template #cell(situacao)="data">
          <b-badge :variant="data.value == 1 ? 'success' : 'secondary'">
            {{ data.value == 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
      </b-table>
    </div>

    <hr />

    <div class="tab-section">
      <h6 class="section-title">Adicionar Condição de Pagamento</h6>

      <b-row>
        <b-col cols="8">
          <b-form-group label="Condição de Pagamento" label-for="select-condpagto">
            <v-select
              id="select-condpagto"
              v-model="condSelecionada"
              :options="condpagtoOpts"
              :loading="carregandoOpts"
              label="label"
              :reduce="o => o.value"
              placeholder="Pesquise e selecione..."
              :filter-by="filtrar"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4" class="d-flex align-items-end pb-1">
          <b-button
            variant="success"
            :disabled="!condSelecionada || salvando"
            @click="adicionar"
          >
            <b-spinner v-if="salvando" small class="mr-1" />
            <feather-icon v-else icon="PlusIcon" size="14" class="mr-1" />
            Adicionar
          </b-button>
        </b-col>
      </b-row>

      <b-alert v-if="mensagem.texto" :variant="mensagem.tipo" show class="mt-2 mb-0">
        {{ mensagem.texto }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import {
  BTable, BRow, BCol, BFormGroup, BButton, BSpinner, BBadge, BAlert,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@/libs/axios';

export default {
  name: 'TabCondPagamento',
  components: {
    BTable, BRow, BCol, BFormGroup, BButton, BSpinner, BBadge, BAlert, vSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      associadas: [],
      condpagtoOpts: [],
      condSelecionada: null,
      carregando: false,
      carregandoOpts: false,
      salvando: false,
      mensagem: { texto: '', tipo: 'success' },
      campos: [
        { key: 'condicaopagamentoid', label: 'Cód. Condição', sortable: true },
        { key: 'situacao', label: 'Situação' },
      ],
    };
  },
  computed: {
    clienteiderp() {
      return this.value?.clienteiderp || null;
    },
  },
  watch: {
    clienteiderp(val) {
      if (val) this.carregar();
    },
  },
  mounted() {
    this.carregarOpts();
    if (this.clienteiderp) this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await axios.get(`/cliente-condpagto/cliente/${this.clienteiderp}`);
        const lista = Array.isArray(data) ? data : (data.data || data.rows || []);
        this.associadas = lista;
      } catch {
        this.associadas = [];
      } finally {
        this.carregando = false;
      }
    },
    async carregarOpts() {
      this.carregandoOpts = true;
      try {
        const { data } = await axios.get('/condicao-pagamento', { params: { perPage: 1000 } });
        const lista = Array.isArray(data) ? data : (data.data || []);
        this.condpagtoOpts = lista.map(c => ({
          label: `${c.condicaopagamentoid} — ${c.condicaopagamentodescricao || ''}`,
          value: c.condicaopagamentoid,
        }));
      } catch {
        this.condpagtoOpts = [];
      } finally {
        this.carregandoOpts = false;
      }
    },
    filtrar(option, label, search) {
      return label.toLowerCase().includes(search.toLowerCase());
    },
    async adicionar() {
      if (!this.condSelecionada || !this.clienteiderp) return;
      this.salvando = true;
      this.mensagem = { texto: '', tipo: 'success' };
      try {
        await axios.post('/cliente-condpagto', {
          clienteiderp: this.clienteiderp,
          condicaopagamentoid: this.condSelecionada,
          situacao: 1,
        });
        this.mensagem = { texto: `Condição "${this.condSelecionada}" associada com sucesso!`, tipo: 'success' };
        this.condSelecionada = null;
        await this.carregar();
      } catch (e) {
        const msg = e?.response?.data?.message || e.message || 'Erro ao associar condição';
        this.mensagem = { texto: msg, tipo: 'danger' };
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.tab-cond-pagamento {
  padding: 0.25rem 0;
}
.tab-section {
  padding: 0.5rem 0;
}
.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #344767;
}
.empty-state {
  display: flex;
  align-items: center;
  color: #6c757d;
  font-size: 0.875rem;
  padding: 0.5rem 0;
}
</style>
